import {
  randomReward,
  newApiKey,
  getApiKey,
  getPoints,
  addPoints,
  addReward,
  getRewards,
  removeReward,
  getListOfWinRewards,
  removeRewardFromListOfWinRewards,
} from './api';

export default {
  async getUserApiKey({ commit, rootState, dispatch }) {
    try {
      const response = await getApiKey(rootState.userStore.user.uid);
      if (response.data?.apiKey?.key) {
        commit('SET_USER_API_KEY', response.data.apiKey.key);
      } else {
        await newApiKey(rootState.userStore.user.uid).then((response2) => {
          commit('SET_USER_API_KEY', response2.data.key);
        });
      }
    } catch (e) {
      console.log(e);
    }
    // get Points
    dispatch('getUserPoints');
  },
  async randomReward({ state, rootState, dispatch }) {
    const { uid } = rootState.userStore.user;
    const allRewards = state.userRewards;
    if (!allRewards && !(allRewards.length > 0)) return;
    try {
      const response = await randomReward({ userId: uid, apiKey: state.userApiKey });
      console.log(response.data);
      dispatch('getListOfWinRewards');
      dispatch('getUserPoints');
    } catch (error) {
      console.log(error);
    }
  },
  async getUserPoints({
    commit, rootState, state, dispatch,
  }) {
    const { uid } = rootState.userStore.user;
    try {
      const response = await getPoints({ userId: uid, apiKey: state.userApiKey });
      commit('SET_USER_POINTS', response.data.points);
      dispatch('getRewards');
    } catch (error) {
      console.log(error);
    }
  },
  async addPoints({ state, rootState, dispatch }, points) {
    const { uid } = rootState.userStore.user;
    try {
      const response = await addPoints({ userId: uid, points, apiKey: state.userApiKey });
      console.log(response.data);
      dispatch('getUserPoints');
    } catch (error) {
      console.log(error);
    }
  },
  async addNewReward({ state, rootState, dispatch }, reward) {
    if (!reward.name || !reward.weighted) {
      console.log('newReward', reward);
      console.log('reward name or weighted is missing');
      return;
    }
    const { uid } = rootState.userStore.user;
    try {
      const response = await addReward({ userId: uid, reward, apiKey: state.userApiKey });
      console.log(response.data);
      dispatch('getUserPoints');
    } catch (error) {
      console.log(error);
    }
  },
  async getRewards({
    state, rootState, commit, dispatch,
  }) {
    dispatch('getListOfWinRewards');
    try {
      const { uid } = rootState.userStore.user;
      const response = await getRewards({ userId: uid, apiKey: state.userApiKey });
      if (!response?.data?.rewards) return;
      const rewards = Object.values(response.data.rewards);
      commit('SET_USER_REWARDS', rewards);
    } catch (error) {
      console.log(error);
    }
  },
  async removeReward({ state, rootState, dispatch }, rewardId) {
    const { uid } = rootState.userStore.user;
    try {
      const response = await removeReward({ userId: uid, rewardId, apiKey: state.userApiKey });
      console.log(response.data);
      dispatch('getRewards');
    } catch (error) {
      console.log(error);
    }
  },
  async getListOfWinRewards({ state, rootState, commit }) {
    const { uid } = rootState.userStore.user;
    try {
      const response = await getListOfWinRewards({ userId: uid, apiKey: state.userApiKey });
      if (response?.data?.listOfWinRewards) {
        const listOfWinRewards = Object.values(response.data.listOfWinRewards);
        commit('SET_USER_WIN_REWARDS', listOfWinRewards);
      } else {
        commit('SET_USER_WIN_REWARDS', []);
      }
    } catch (error) {
      console.log(error);
    }
  },
  // removeRewardFromListOfWinRewards
  async removeRewardFromListOfWinRewards({ state, rootState, dispatch }, rewardId) {
    const { uid } = rootState.userStore.user;
    try {
      await removeRewardFromListOfWinRewards({
        userId: uid, rewardId, apiKey: state.userApiKey,
      });
      dispatch('getListOfWinRewards');
    } catch (error) {
      console.log(error);
    }
  },
};
